module.exports = __webpack_public_path__ + "9daa999dbc04349a49b66fbe6cfcfb3d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-31.png
// module id = 3294
// module chunks = 0